module.exports = __webpack_public_path__ + "static/media/42.c763cd76.png";